import { ColumnSetting } from "lib/types/models";
import { NoticeColumns } from "../notices/utils";
import { SupplierColumns } from "../suppliers/utils";

export const DEFAULT_SUPPLIER_COLUMNS: ColumnSetting<SupplierColumns>[] = [
  { title: "Name", field: "name", disabled: true },
  { title: "Lots", field: "frameworkLots" },
  { title: "Last activity", field: "frameworkLastActivity" },
  { title: "Call-offs", field: "frameworkCallOffs" },
  { title: "Is SME", field: "sme" },
];

export const ALL_SUPPLIER_COLUMNS: ColumnSetting<SupplierColumns>[] = [
  ...DEFAULT_SUPPLIER_COLUMNS,
  { title: "Country", field: "country" },
];

export const DEFAULT_CALL_OFF_NOTICE_COLUMNS: NoticeColumns[] = [
  "relevance_score",
  "title",
  "suppliers",
  "value",
  "published_date",
];
